import React from 'react';

const DownloadSvg = (props) => (
    <svg viewBox="0 0 24 24" {...props}>
        <path fill="#231F20" d="M16 16v1h5v4H3v-4h5v-1H2v6h20v-6z" />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            fill="#231F20"
            d="M17.3 11.4l-4.8 4.7V2h-1v14.1l-4.8-4.7-.7.7 6 5.9 6-5.8z"
        />
    </svg>
);

DownloadSvg.displayName = 'DownloadSvg';
export default DownloadSvg;
